/** UI-only Zustand stores — sidebar state, navigation, panel visibility. */

import { create } from "zustand";

interface UiState {
  sidebarCollapsed: boolean;
  compassPanelOpen: boolean;
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  setCompassPanelOpen: (open: boolean) => void;
}

export const useUiStore = create<UiState>((set) => ({
  sidebarCollapsed: false,
  compassPanelOpen: true,

  toggleSidebar: () =>
    set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),

  setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),

  setCompassPanelOpen: (open) => set({ compassPanelOpen: open }),
}));
